import * as React from "react";
const SvgMinusSmall = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M12.666 7.375a.625.625 0 1 1 0 1.25H3.333a.625.625 0 1 1 0-1.25z" /></svg>;
export default SvgMinusSmall;